import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { server } from "../server";

export const fetchExpenses = createAsyncThunk(
  "expenses/fetchExpenses",
  async (_, thunkAPI) => {
    try {
      const response = await axios.post(
        `${server}/expenses_getall_and_get_by_date_mongodb`,
        {},
        {
          headers: {
            Authorization: `${localStorage.getItem("token")}`,
          },
        },
      );

      const responseData = response.data?.["body-json"]?.body?.data;

      if (Array.isArray(responseData)) {
        return responseData;
      } else {
        console.error("Invalid data format from API", response.data);
        return thunkAPI.rejectWithValue("Invalid data format");
      }
    } catch (error) {
      console.error("Error fetching expenses:", error);
      return thunkAPI.rejectWithValue(error.message);
    }
  },
);

const expensesSlice = createSlice({
  name: "expenses",
  initialState: {
    data: [],
    loading: true,
    error: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchExpenses.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(fetchExpenses.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(fetchExpenses.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export default expensesSlice.reducer;
